import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-733d0e96")

_pushScopeId("data-v-733d0e96")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  class: "pa-4",
  style: {"width":"100%"}
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "pa-4",
  style: {"text-align":"center"}
}, " 扫描下方二维码查看当前健康信息 ", -1)
const _hoisted_4 = { class: "py-6 text-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_my_card, { class: "card" }, {
        default: _withId(() => [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: $setup.url,
              style: {"width":"70vw","height":"70vw"},
              onClick: _cache[1] || (_cache[1] = (...args) => ($setup.getQrCode(...args)))
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
})